import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { isMobile } from "react-device-detect"
import styled from "styled-components"

import Month from "../elements/Month"
import Block from "../elements/Block"
import Photo from "../elements/Photo"
import Video from "../elements/Video"
import Gif from "../elements/Gif"

import event_3 from "../../images/events/may/event-3.mp4"
import event_4 from "../../images/events/may/event-4.gif"

const Grid = styled.div`
  display: grid;
  grid-gap: var(--gutter-l);
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto auto;
  grid-template-areas: ". event-1 event-1 event-1" "event-2 event-2 event-2 ." ". event-3 event-3 event-3" ". event-4 event-4 event-4" "culture-1 culture-1 . ." ". . culture-2 culture-2";
  .event-1 {
    grid-area: event-1;
  }
  .event-2 {
    grid-area: event-2;
  }
  .event-3 {
    grid-area: event-3;
  }
  .event-4 {
    grid-area: event-4;
  }
  .culture-1 {
    grid-area: culture-1;
  }
  .culture-2 {
    grid-area: culture-2;
  }
  @media (min-width: 768px) {
  }
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: auto auto auto auto auto;
    grid-template-areas: ". event-1 event-1 ." ". . event-2 event-2" "event-3 event-3 event-2 event-2" "event-3 event-3 event-4 event-4" ". . event-4 event-4" ". culture-1 . ." ". culture-1 culture-2 ." ". . culture-2 .";
  }
  @media (min-width: 1200px) {
  }
`

const May = () => {
  const data = useStaticQuery(graphql`
    query {
      mayEventOne: file(relativePath: { eq: "events/may/event-1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 800, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mayEventTwo: file(relativePath: { eq: "events/may/event-2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 446, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mayEventThreeFB: file(relativePath: { eq: "events/may/event-3-fb.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 487, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mayCultureOne: file(relativePath: { eq: "events/may/culture-1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 507, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mayCultureTwo: file(relativePath: { eq: "events/may/culture-2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 400, maxHeight: 522, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Month name="may">
      <Grid>
        <Block className="event-1">
          <Photo img={data.mayEventOne} maxWidth={800} maxHeight={800} />
          <h4 style={{ maxWidth: 800 }}>
            We launched a new brand and website for{" "}
            <a
              href="https://www.motorhappy.co.za/"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              MotorHappy
            </a>
            .
          </h4>
        </Block>
        <Block className="event-2">
          <Photo img={data.mayEventTwo} maxWidth={600} maxHeight={446} />
          <h4 style={{ maxWidth: 600 }}>
            The site is filled with slick illustrations.
          </h4>
        </Block>
        <Block className="event-3">
          {isMobile ? (
            <Photo img={data.mayEventThreeFB} maxWidth={800} maxHeight={487} />
          ) : (
            <Video src={event_3} width={480} height={360} />
          )}
          <h4 style={{ maxWidth: 400 }}>
            And this little guy is{" "}
            <a
              href="https://vimeo.com/356150310"
              rel="noreferrer noopener"
              target="_blank"
              className="mouse-link"
            >
              OtO
            </a>
            , the mascot we conceptualised, designed and animated.
          </h4>
        </Block>
        <Block className="event-4">
          <Gif src={event_4} maxWidth={453} maxHeight={256} />
          <h4 style={{ maxWidth: 453 }}>
            As the ultimate geeks, ‘May the 4th’ was a sacred day of all things
            Star Wars.
          </h4>
        </Block>
        <Block className="culture-1">
          <Photo img={data.mayCultureOne} maxWidth={600} maxHeight={507} />
          <h4 style={{ maxWidth: 600 }}>
            If you can’t take the mountain to Pretoria. Bring Pretoria to the
            mountain.
          </h4>
        </Block>
        <Block className="culture-2">
          <Photo img={data.mayCultureTwo} maxWidth={400} maxHeight={522} />
          <h4 style={{ maxWidth: 400 }}>
            Oh, and Jason, a tech lead, had a B-day.
          </h4>
        </Block>
      </Grid>
    </Month>
  )
}

export default May
